export default class phoneCaller {
  static callNumber(number) {
    let telNumber = '';
    if (String(number).indexOf('0') === 0) {
      telNumber = String(number).substring(1);
    } else {
      telNumber = number;
    }

    // 台灣國際區碼: +886
    window.location.assign(`tel:+886-${telNumber}`);
    return telNumber;
  }
}
